import { IconCollection } from "components/Icon/IconCollection";
import { ResourceConfig } from "config/config";
import {
    deleteActionSignature,
    DeleteListAction,
    deletePermanentlyActionSignature,
    duplicateActionSignature,
    exportActionSignature,
    moveToLocationActionSignature,
    PermanentlyDeleteListAction,
} from "containers/Resources/components/CommonActions/CommonActions";
import {
    commentsTab,
    metadataTab,
    metadataTabKey,
} from "containers/Resources/screens/ResourcesSingle/constants";
import resource from "./resource";

const commonGraphqlBody = `
    ${resource.graphql.resourceBody}
`;

const resourceName = "role";

const config: ResourceConfig = {
    label: "Role",
    icon: IconCollection.badge,
    resourceName,
    resourceClass: "resource",
    defaultActiveTab: metadataTabKey,
    graphql: {
        resource: resourceName,
        resourceBody: `
            ${commonGraphqlBody}
            role_permission_list_role_id(limit:10, offset:0, order: "+operation",){
                role_permission_count
                role_permission_list {
                    id
                    project_id
                    project_id_project{
                        name
                    }
                    table_type
                    operation
                    object_template_id
                    object_template_id_object_template{
                        name
                    }
                    role_id_role{
                        deleted_at
                        is_readonly
                    }
                }
            }
        `,
        resourceSingleQueryBody: `
            ${commonGraphqlBody}
            role_permission_list_role_id(limit:$rolePermissionLimit, order: $rolePermissionOrder, offset: $rolePermissionOffset){
                role_permission_count
                role_permission_list {
                    id
                    project_id
                    project_id_project{
                        name
                    }
                    table_type
                    operation
                    object_template_id
                    object_template_id_object_template{
                        name
                    }
                    role_id_role{
                        deleted_at
                        is_readonly
                    }
                }
            }
        `,
        resourceBodyListing: `
            ${resource.graphql.resourceBody}
        `,
        createVariables: `
            ${resource.graphql.createVariables(resourceName)}
        `,
        createQuery: `
            ${resource.graphql.createQuery(resourceName)}
        `,
        updateVariables: `
            ${resource.graphql.updateVariables(resourceName)}
        `,
        updateQuery: `
            ${resource.graphql.updateQuery(resourceName)}
        `,
        singleQueryVariables: `
            $rolePermissionLimit: Int,
            $rolePermissionOffset: Int,
            $rolePermissionOrder: String,`,
    },
    layout: [
        {
            partial: "pageHeaderForm",
        },
        { partial: "form" },
        { partial: "roleIdentityList" },
        { partial: "rolePermissionList" },
        {
            partial: "tabs",
            config: {
                tabs: [metadataTab.tab, commentsTab.tab],
                content: [metadataTab.content, commentsTab.content],
            },
        },
    ],
    form: [],
    actions: {
        shown: [],
        hidden: [
            duplicateActionSignature,
            exportActionSignature,
            moveToLocationActionSignature,
            deleteActionSignature,
            deletePermanentlyActionSignature,
        ],
    },
    listActions: {
        shown: [],
        hidden: [
            { key: "delete", action: DeleteListAction },
            { key: "deletePermanently", action: PermanentlyDeleteListAction },
        ],
    },
};
export default config;
